import type { InputHTMLAttributes } from 'react'
import { Field, FIELD_CONTROL, FIELD_INVALID } from './Field'
import { cx } from '@/lib/cx'

interface Props extends Omit<InputHTMLAttributes<HTMLInputElement>, 'id'> {
  label: string
  required?: boolean
  error?: string | undefined
  hint?: string | undefined
}

export function TextField({ label, required, error, hint, className, ...rest }: Props) {
  return (
    <Field label={label} required={required ?? false} error={error} hint={hint}>
      {({ id, describedBy, invalid }) => (
        <input
          id={id}
          className={cx(FIELD_CONTROL, invalid && FIELD_INVALID, className)}
          aria-invalid={invalid || undefined}
          aria-describedby={describedBy}
          // Browser autofill offering someone's home address inside a patient
          // record is both wrong and a leak.
          autoComplete="off"
          {...rest}
        />
      )}
    </Field>
  )
}
